export enum PaymentSlipDeliveryType {
  DOWNLOAD = 'download',
  MAIL = 'mail',
}
